import axios from '@lib/axios';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

interface Props {
  contentId?: string;
	onSuccess?: (res: AxiosResponse) => void;
  onError?: () => void;
}

export const useSendTestEmail = ({
  contentId,
	onSuccess,
  onError
}: Props) => {
	const {
		mutate: onSendTestEmail,
		...rest
	} = useMutation({
		mutationFn: async () => axios.post(`/contents/${contentId}/send-email-test`),
		onSuccess,
    onError
	});

	return { onSendTestEmail, ...rest };
};